import { render } from "./featherIcons.vue?vue&type=template&id=56a8cb23"
import script from "./featherIcons.vue?vue&type=script&lang=js"
export * from "./featherIcons.vue?vue&type=script&lang=js"
script.render = render

export default script